import React, { useState, useEffect } from 'react';
import {  DropdownMenu, Button, Link, ContextualAlert, DownloadIcon, TextInput, BodyText, LoadingSpinner, Row, Col, CaptionText, Pill } from '@paypalcorp/pp-react';
import { get, find } from 'lodash';
import ReactHtmlParser from 'react-html-parser';
import { show, hide } from '../../common/domUtils';
import { formatDateWithLang, getDaysDifference, parseDate, formatToParts, langSpecificTimeZone } from '../../common/dateUtils';
import * as FPT from '../../utility/fpt';
import DateRange from '../../common/components/DateRange';
import { parseMessages } from '../../utilityHelper';
import { fetchResponse } from '../../common/serviceRequest';
import { launchRedirect } from '../../lib/validate';
import ActivityTable from './ActivityTable';
import withTheme from '../../common/withTheme';
const activityMsg = parseMessages("givingfund");

const ActivityTab = ({ isDirectModel, isBrazil }) => {
    const lang = `${document.getElementsByTagName('html')[0].getAttribute('lang')}`;
    const [showNoRecordsMsg, setShowNoRecordsMsg] = useState(false);
    const [showRecordsError, setShowRecordsError] = useState(false);
    const [payoutDateFrom, setPayoutDateFrom] = useState(null);
    const [payoutDateTo, setPayoutDateTo] = useState(null);
    const [scrollId, setScrollId] = useState('');
    const [dateRangeError, setDateRangeError] = useState(false);
    const [dateRangeInvalidError, setDateRangeInvalidError] = useState(false);
    const [activityTransactionData, setActivityTransactionData] = useState([]);
    const [donorNameError, setDonorNameError] = useState(false);
    const [donorName, setDonorName] = useState('');
    const [partnerIndex, setPartnerIndex] = useState(-1);
    const [selectedPartner, setSelectedPartner] = useState('');
    const [programIndex, setProgramIndex] = useState(-1);
    const [selectedProgram, setSetSelectedProgram] = useState('');
    const [partner, setPartner] = useState('');
    const [payoutType, setPayoutType] = useState('');
    const [programName, setProgramName] = useState('');
    const [activityMessage, setActivityMessage] = useState('');

    const partnerInfo = JSON.parse(document.getElementById('data-partner-list') && document.getElementById('data-partner-list').innerHTML || '{}');
    const pageDetails = JSON.parse(document.getElementById('data-page-details') && document.getElementById('data-page-details').innerHTML || '{}');

    const partnerOptions = partnerInfo.map(function (partner_info) {
        return {
            primaryText: partner_info.partner_name,
            value: partner_info.partner_name
        };
    });

    let programOptions = [];
    if (partnerIndex !== -1) {
        let i = 0;
        let partnerSelected = partnerOptions[partnerIndex].primaryText;
        let programIndex = partnerInfo.find(function (item) {
            return item.partner_name === partnerSelected;
        });
        programIndex.program_info.forEach(function (program) {
            programOptions[i] = {
                primaryText: program.description,
                value: `${program.gp_program_id}`
            };
            i++;
        });
    } else {
        let i = 0;
        partnerInfo.forEach(function (item) {
            item.program_info.forEach(function (program) {
                programOptions[i] = {
                    primaryText: program.description,
                    value: `${program.gp_program_id}`
                };
                i++;
            });
        });
    }

    const onDonorNameInputFocus = () => {
        setDonorNameError(false);
    }

    const handlePartnerSelect = (e) => {
        setPartnerIndex(e.target.selectedIndex);
        setSelectedPartner(e.target.value);
    }

    const handleProgramSelect = (e) => {
        setProgramIndex(e.target.selectedIndex);
        setSetSelectedProgram(e.target.value);
    }

    useEffect(() => {
        let dateFromTo = new Date();
        let dateToMonth = String(dateFromTo.getMonth() + 1).padStart(2, '0');
        let dateToDay = String(dateFromTo.getDate()).padStart(2, '0');
        let dateToYear = dateFromTo.getFullYear();
        let dateOffset = (24 * 60 * 60 * 1000) * 30;
        dateFromTo.setTime(dateFromTo.getTime() - dateOffset);
        let dateFromMonth = String(dateFromTo.getMonth() + 1).padStart(2, '0');
        let dateFromDay = String(dateFromTo.getDate()).padStart(2, '0');
        let dateFromYear = dateFromTo.getFullYear();
        let data = {
            payoutDateFrom: `${dateFromYear}-${dateFromMonth}-${dateFromDay}`,
            payoutDateTo: `${dateToYear}-${dateToMonth}-${dateToDay}`,
            _csrf: document.body.getAttribute('data-csrf')
        }
        hide('.middleSection');
        hide('#activityResult');
        FPT.trackPage('main:givingfund:activity');
        fetchActivityTransactiondata(data);
        activityMessages();
    }, []);

    const fetchActivityTransactiondata = (data) => {
        hide('.viewmoreLink');
        show('.activityLoaderSpin'); 
        let payloadData = Object.assign({}, data);
        payloadData.payoutDateFrom = payloadData.payoutDateFrom.replaceAll('-', '');
        payloadData.payoutDateTo = payloadData.payoutDateTo.replaceAll('-', ''); 
        fetchResponse('/givingfund/donationActivity', 'POST', payloadData)
            .then((result) => {
                setShowNoRecordsMsg(true);
                setDonorName(data.donorName ? data.donorName : '');
                setPartner(data.partnerName ? data.partnerName : '');
                setPayoutType(data.payoutType ? data.payoutType : '');
                setProgramName(data.programName ? data.programName : '');
                setPayoutDateFrom(data.payoutDateFrom);
                setPayoutDateTo(data.payoutDateTo);
                hide('.activityLoaderSpin');
                show('.middleSection');
                show('#activityResult');
                if (result.status != 'error') {
                    setActivityTransactionData(get(result, 'transactions', []));
                    setScrollId(result.scroll_id);
                    setShowRecordsError(false);
                    if (result.scroll_id !== '') {
                        show('.viewmoreLink');
                    } else {
                        hide('.viewmoreLink');
                    }
                } else {
                    throw new Error;
                }
            }).catch(() => {
                setActivityTransactionData([]);
                setShowRecordsError(true);
                setShowNoRecordsMsg(false);
                setScrollId('');
                hide('.viewmoreLink');
            });
    }

    const handleFilterSearch = (filter) => {
        let data = {};
        data.donorName = (filter != 'clearAllFilter') ? document.getElementById('donorName').value : '';
        data.partnerName = (partnerIndex != -1 && filter != 'clearAllFilter' && filter != 'clearPartnerFilter') ? partnerOptions[partnerIndex].primaryText : '';
        data.payoutType = (programIndex != -1 && filter != 'clearAllFilter' && filter != 'clearProgramFilter' && filter != 'clearPartnerFilter') ? programOptions[programIndex].value : '';
        data.programName = (programIndex != -1 && filter != 'clearAllFilter' && filter != 'clearProgramFilter' && filter != 'clearPartnerFilter') ? programOptions[programIndex].primaryText : '';

        if (data.donorName.length > 0 && data.donorName.length < 3) {
            setDonorNameError(true);
            return false;
        }

        let dateFromInitial, dateToInitial, formatteddatepartsFrom, formatteddatepartsTo;

        if (filter == 'clearAllFilter' || filter == 'clearDateFilter') {
            let dateFromToInitial = new Date();
            dateToInitial = new Intl.DateTimeFormat(lang).format(dateFromToInitial);
            let dateOffset = (24 * 60 * 60 * 1000) * 30;
            dateFromToInitial.setTime(dateFromToInitial.getTime() - dateOffset);
            dateFromInitial = new Intl.DateTimeFormat(lang).format(dateFromToInitial);
        } else {
            dateFromInitial = document.getElementById('text-input-rangeStart').value;
            dateToInitial = document.getElementById('text-input-rangeEnd').value;
        }

        formatteddatepartsFrom = formatToParts(parseDate(dateFromInitial, lang), lang);
        formatteddatepartsTo = formatToParts(parseDate(dateToInitial, lang), lang);

        let diffDays = getDaysDifference(parseDate(dateFromInitial, lang), parseDate(dateToInitial, lang));
        if (diffDays > 30) {
            setDateRangeError(true);
            return false;
        } else {
            setDateRangeError(false);
        }
        if (diffDays < 0) {
            setDateRangeInvalidError(true);
            return false;
        } else {
            setDateRangeInvalidError(false);
        }

        data.payoutDateFrom = `${formatteddatepartsFrom.year}-${formatteddatepartsFrom.month}-${formatteddatepartsFrom.day}`;
        data.payoutDateTo = `${formatteddatepartsTo.year}-${formatteddatepartsTo.month}-${formatteddatepartsTo.day}`;
        data._csrf = document.body.getAttribute('data-csrf');

        setActivityTransactionData([]);
        setScrollId('');
        setShowNoRecordsMsg(false);

        let pageParams = {
            payoutDateFrom: data.payoutDateFrom,
            payoutDateTo: data.payoutDateTo,
            partner: data.partnerName,
            payoutType: data.payoutType,
            donorName: data.donorName
        }
        FPT.trackButtonClickWithData('activity_search', { pageParams: pageParams });
        hide('.middleSection');
        hide('#activityResult');
        fetchActivityTransactiondata(data);
    }

    const downloadActivityStatement = () => {
        let data = {
            payoutDateFrom: payoutDateFrom.replaceAll('-',''),
            payoutDateTo: payoutDateTo.replaceAll('-',''),
            partner: partner,
            payoutType: payoutType,
            donorName: donorName
        }
        FPT.trackButtonClickWithData('activity_download', { pageParams: data });
        launchRedirect(`/givingfund/downloadDonationActivity?payoutDateFrom=${data.payoutDateFrom}&payoutDateTo=${data.payoutDateTo}&donorName=${data.donorName}&partnerName=${data.partner}&payoutType=${data.payoutType}`, true);

    }

    const clearDateFilter = () => {
        handleFilterSearch('clearDateFilter');
    }

    const clearDonorNameFilter = () => {
        document.getElementById('donorName').value = '';
        handleFilterSearch('clearDonorNameFilter');
    }

    const clearPartnerFilter = () => {
        setSelectedPartner('');
        setSetSelectedProgram('');
        handleFilterSearch('clearPartnerFilter');
    }

    const clearProgramFilter = () => {
        setSetSelectedProgram('');
        handleFilterSearch('clearProgramFilter');
    }

    const clearAllFilter = () => {
        setSelectedPartner('');
        setSetSelectedProgram('');
        document.getElementById('donorName').value = '';
        handleFilterSearch('clearAllFilter');

    }

    const viewMore = () => {
        let data = {
            payoutDateFrom: payoutDateFrom,
            payoutDateTo: payoutDateTo,
            donorName: donorName,
            partnerName: partner,
            payoutType: payoutType,
            scrollId: scrollId,
        }
        FPT.trackButtonClickWithData('activity_viewmore', { pageParams: data });
        data._csrf = document.body.getAttribute('data-csrf');
        fetchActivityTransactiondata(data);
    }

    const displayDateRangeFilter = (textToReplace) => {
        if(payoutDateFrom && payoutDateTo) {
            let fromDateLocalOffset = langSpecificTimeZone(payoutDateFrom, lang, { year: 'numeric', month: 'short', day: 'numeric' });
            let toDateLocalOffset = langSpecificTimeZone(payoutDateTo, lang, { year: 'numeric', month: 'short', day: 'numeric' });
            let dateRange = get(activityMsg, textToReplace).replace('{FROM_DATE}', fromDateLocalOffset);
            return dateRange.replace('{TO_DATE}', toDateLocalOffset);
        }
    }

    const checkDefaultDateRange = () => {
        let fromDate, toDate;
        if (payoutDateFrom && payoutDateTo) {
            fromDate = langSpecificTimeZone(payoutDateFrom, lang, { year: 'numeric', month: '2-digit', day: '2-digit' });
            toDate = langSpecificTimeZone(payoutDateTo, lang, { year: 'numeric', month: '2-digit', day: '2-digit' });
            let endDateObj = new Date();
            let endDateFormated = formatDateWithLang(endDateObj, lang);
            let dateOffset = (24 * 60 * 60 * 1000) * 30;
            endDateObj.setTime(endDateObj.getTime() - dateOffset);
            let startDateFormated = formatDateWithLang(endDateObj, lang);
            if (fromDate == startDateFormated && toDate == endDateFormated) {
                return true;
            }
        }
        return false;
    }

    const donationSummaryDesc = activityMsg.activity.donationSummaryDesc.replace('{PAYOUT_DATE}', get(pageDetails, 'payoutDate', 25));
    const donationSummaryDescDM = activityMsg.activity.donationSummaryDescDM.replace('{PAYOUT_DATE}', get(pageDetails, 'payoutDate', 25));
    const donationSummaryDescBR = activityMsg.activity.donationSummaryDescBR.replace('{PAYOUT_DATE}', get(pageDetails, 'payoutDate', 25));

    const activityMessages = () => {
        switch (true) {
            case (isDirectModel && isBrazil):
                setActivityMessage(ReactHtmlParser(donationSummaryDescBR));
                break;
            case (isDirectModel):
                setActivityMessage(ReactHtmlParser(donationSummaryDescDM));
                break;
            default:
                setActivityMessage(ReactHtmlParser(donationSummaryDesc));
        }

        return activityMessage
    }

    return (
        <>
            <section className="section">
                <Row>
                    <Col xxl={4}>
                        <TextInput
                            id="donorName"
                            value=""
                            label={get(activityMsg, 'activity.donorname')}
                            errorText={donorNameError && get(activityMsg, 'activity.donornameshort')}
                            onFocus={onDonorNameInputFocus}
                        />
                    </Col>
                    <Col xxl={4}>
                        <DropdownMenu
                            label={get(activityMsg, 'activity.allpartners')}
                            options={partnerOptions}
                            onChange={handlePartnerSelect}
                            value={selectedPartner}
                        />
                    </Col>
                    <Col xxl={4}>
                        <DropdownMenu
                            label={get(activityMsg, 'activity.allprograms')}
                            options={programOptions}
                            onChange={handleProgramSelect}
                            value={selectedProgram}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: '16px' }}>
                    <Col xxl={5}>
                        <DateRange dateFrom={payoutDateFrom} dateTo={payoutDateTo} defaultDateRange={parseInt(30)} />
                        {(dateRangeError || dateRangeInvalidError) &&
                            <ContextualAlert type="error" style={{ margin: 'auto' }}>
                                {dateRangeError && get(activityMsg, 'activity.daterangeerror') || dateRangeInvalidError && get(activityMsg, 'activity.daterangeinvaliderror')}
                            </ContextualAlert>
                        }
                    </Col>
                    <Col xxl={7} style={{ paddingTop: '8px' }}>
                        <Button onClick={handleFilterSearch} id="searchButton">{get(activityMsg, 'activity.filter')}</Button>
                    </Col>
                </Row>
            </section>
            <section className="middleSection" style={{ margin: '6px 0' }}>
                <Row>
                    <Col>
                        <CaptionText strong style={{ display: 'inline', marginRight: '24px' }}>{get(activityMsg, `activity.searchresults`)}</CaptionText>
                        {(checkDefaultDateRange()) && <Button size="sm" className="searchAppliedBtn">{displayDateRangeFilter('activity.defaultdaterangefromto')}</Button>}
                        {(!checkDefaultDateRange()) && <Pill className="pillStyle" value="customDateRange" dismissButtonLabel={get(activityMsg, 'dismiss')} onDismiss={clearDateFilter}>{displayDateRangeFilter('activity.daterangefromto')}</Pill>}
                        {donorName && <Pill className="pillStyle" value="donorName" dismissButtonLabel={get(activityMsg, 'dismiss')} onDismiss={clearDonorNameFilter}>{get(activityMsg, `activity.donorname`)}: {donorName}</Pill>}
                        {partner && <Pill className="pillStyle" value="partner" dismissButtonLabel={get(activityMsg, 'dismiss')} onDismiss={clearPartnerFilter}>{get(activityMsg, `activity.partner`)}: {get(find(partnerOptions, { primaryText: partner }), 'primaryText')}</Pill>}
                        {programName && <Pill className="pillStyle" value="programName" dismissButtonLabel={get(activityMsg, 'dismiss')} onDismiss={clearProgramFilter}>{get(activityMsg, `activity.program`)}: {get(find(programOptions, { primaryText: programName }), 'primaryText')}</Pill>}
                        {(donorName || partner || programName) && <Link size="sm" onClick={clearAllFilter}>{get(activityMsg, `activity.clearallfilter`)}</Link>}
                    </Col>
                </Row>
                <Row style={{ marginTop: '50px', marginBottom: '20px', lineHeight: '24px' }}>

                    <Col xxl={10} ><BodyText>{activityMessage}</BodyText></Col>
                    <Col xxl={2} className="downloadCol">
                        <Link onClick={downloadActivityStatement} style={{ float: 'right' }} leftIcon={<DownloadIcon style={{ color: 'black' }} name="v2-download" size="sm" />}>{get(activityMsg, `download`)}</Link>
                    </Col>
                </Row>
            </section>
            <ActivityTable activityTransactionData={activityTransactionData} showNoRecordsMsg={showNoRecordsMsg} showRecordsError={showRecordsError} />
            <section className="section viewmore">
                    <Button className="viewmoreLink" secondary onClick={viewMore}>
                        {get(activityMsg, 'loadmore')}
                    </Button>
                    <LoadingSpinner className="activityLoaderSpin" id="activityLoaderSpin" size="md" screenReaderText={get(activityMsg, 'loading')} />
            </section>
        </>
    );
}

export default withTheme(ActivityTab);